const checkVkLink = (link: string | undefined) => {
  if (!link) return false
  return link.includes('vk.com')
}

const extractOidAndId = (url: string) => {
  if (url.includes('video_ext.php')) {
    const params = new URLSearchParams(url.split('?')[1])
    const oid = params.get('oid')
    const id = params.get('id')
    return { oid, id }
  }

  const regex = /video(-?\d+)_(\d+)/
  const match = url.match(regex)

  if (match) {
    const oid = match[1]
    const id = match[2]
    return { oid, id }
  } else {
    return { oid: '', id: '' }
  }
}

export { checkVkLink, extractOidAndId }
